module.exports = __webpack_public_path__ + "img/icon_wancheng.019fd06b.png";